//@flow
import React, { Component } from 'react';
import { SummaryFooterP, StatusSpan } from './CommissionPaidShowStyles';

type Props = { status: string };
export default class SummaryFooter extends Component<Props> {
  render() {
    const color = this.props.status === 'pending' ? 'orange' : 'green';
    return (
      <SummaryFooterP>
        Status:
        <StatusSpan color={color}> {this.props.status}</StatusSpan>
      </SummaryFooterP>
    );
  }
}
